import React from 'react';

function Reserve() {
  return (
    <div className="reserve-page">
      <section className="hero-section" style={{backgroundImage: 'url(/images/reserve-bg.jpg)', height: '60vh'}}>
        <div className="hero-content">
          <h1 className="hero-title">RESERVE A TABLE</h1>
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="two-column">
            <div>
              <h2 className="section-title">MAKE A RESERVATION</h2>
              <p className="section-text" style={{marginBottom: '30px'}}>
                Join us for an unforgettable dining experience. Reserve your table today and let us take you 
                on a culinary journey through Greece.
              </p>
              {/* Eat App Reservation Widget */}
              <div style={{position: 'relative', paddingBottom: '150%', width: '100%', height: 0, maxWidth: '500px'}}>
                <iframe
                  title="Eat Widget"
                  frameBorder="0"
                  src="https://eatapp.co/reserve/yamas-nairobi?source=iframe"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: '4px'
                  }}
                />
              </div>
            </div>
            <div>
              <img src="/images/restaurant-interior.jpg" alt="Restaurant" className="content-image" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Reserve;
